// third-party
import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import { openSnackbar } from './snackbar';
import { dispatch } from '../index';
import transformAllHotelData from '../helpers/transformAllHotelData';
import transformFilterOption from '../helpers/transformFilterOption';
import { devConsolelog } from 'helpers/utilityFunctions';
import { setFormDataProviderTraceId } from './quotes';

const filters = {
    freeBreakfast: false,
    hotelName: '',
    isRefundable: false,
    tags: [],
    priceRange: {
        min: null,
        max: null
    },
    type: [],
    ratings: [],
    reviewRatings: null,
    subLocationIds: [],
    areaCodes: [],
    facilities: []
};

const initialState = {
    hotelsData: {
        hotels: []
    },
    hotelLoading: false,
    providerTraceId: null,
    traceId: null,
    filterOPtion: {},
    payload: {
        destinationCode: '',
        autoSuggestResult: null,
        checkIn: '',
        checkOut: '',
        filterBy: filters,
        contractedHotels: false,
        occupancies: [
            {
                childAges: [],
                numOfAdults: 2,
                infantCount: 0
            }
        ],
        page: 1,
        numberOfNights: 1,
        sortBy: null,
        requirement_code: '',
        providerTraceId: null,
        traceId: null
    }
};

const hhiHotelListSlice = createSlice({
    name: 'hhiHotelList',
    initialState,
    reducers: {
        setHotelLoading(state, action) {
            state.hotelLoading = action.payload;
        },
        setHotels(state, action) {
            state.hotelsData = action.payload;
        },
        updateFilters(state, action) {
            state.payload.filterBy = { ...state.payload.filterBy, ...action.payload };
        },
        updatePayload(state, action) {
            state.payload = { ...state.payload, ...action.payload };
        },
        setFilterOPtions(state, action) {
            state.filterOPtion = { ...state.filterOPtion, ...action.payload };
        },
        setTraceId(state, action) {
            state.traceId = action.payload;
        },
        setProviderTraceId(state, action) {
            state.providerTraceId = action.payload;
        },
        resetToIntialState() {
            return initialState;
        },
        setEmptyHotels(state) {
            state.hotelsData.hotels = [];
        }
    }
});

export const {
    setHotelLoading,
    setHotels,
    updateFilters,
    updatePayload,
    setFilterOPtions,
    setTraceId,
    setProviderTraceId,
    resetToIntialState,
    setEmptyHotels
} = hhiHotelListSlice.actions;

export default hhiHotelListSlice.reducer;

export const getHotelList = (
    reqBody,
    signal = new AbortController().signal,
    isInfiniteScrollActive = false,
    previousHotelList = [],
    tabValue = 0
) => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}hhi/hotels/${reqBody?.destinationCode}/hotel-list`;

    return async () => {
        try {
            dispatch(setHotelLoading(true));

            const response = await axios.post(url, reqBody, {
                headers: { source: 'mweb' },
                signal
            });

            const hotelsData = transformAllHotelData(response.data);
            const filterData = transformFilterOption(response.data);
            const { traceId, providerTraceId } = response?.data?.results?.[0] || {};
            dispatch(setFilterOPtions(filterData));
            if (isInfiniteScrollActive) {
                dispatch(setHotels({ ...hotelsData, hotels: [...previousHotelList, ...(hotelsData.hotels || [])] }));
            } else {
                dispatch(setHotels(hotelsData));
            }
            dispatch(setTraceId(traceId));
            dispatch(setFormDataProviderTraceId({ tabValue, providerTraceId }));
            dispatch(setProviderTraceId(providerTraceId));
            dispatch(setHotelLoading(false));
        } catch (error) {
            console.log('errrrr->', error);
            if (axios.isCancel(error)) {
                console.log('Request canceled', error.message);
                return;
            }
            dispatch(
                openSnackbar({
                    open: true,
                    message: DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: { color: 'error' },
                    close: false
                })
            );
            dispatch(setHotelLoading(false));
        }
    };
};

export const getFilterHotelList = (reqBody) => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}hhi/hotels/${reqBody.destinationCode}/hotel-list`;

    return async () => {
        try {
            dispatch(setHotelLoading(true));

            const response = await axios.post(url, reqBody, {
                headers: { source: 'mweb' }
            });
            const hotelsData = transformAllHotelData(response.data);
            const { providerTraceId } = response.data.results[0];
            dispatch(setProviderTraceId(providerTraceId));

            dispatch(setHotels(hotelsData));
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: { color: 'error' },
                    close: false
                })
            );
        } finally {
            devConsolelog('yeehhhshhshshhshshhs');
            dispatch(setHotelLoading(false));
        }
    };
};

export const getAreaCode = (destinationCode, payload = {}, isHotelListFlow, signal, tabValue = 0) => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}auto-quote/areas?all=true&destinationCode=${destinationCode}`;
    const selectedArea = payload?.filterBy?.areaCodes[0] || '';
    // eslint-disable-next-line consistent-return
    return async () => {
        try {
            const { data } = await axios.get(url);
            const AREA_CODES = data.response.results.map((areaData) => ({
                label: areaData.name,
                value: areaData.code
            }));
            const currentArea = data.response.results.find((areaData) => areaData.code === selectedArea);
            const { providerLocationId = null } = currentArea || {};
            devConsolelog('hol543543', data, payload, currentArea);
            dispatch(setFilterOPtions({ AREA_CODES }));
            if (isHotelListFlow) {
                if (providerLocationId) {
                    const updatedPayload = {
                        ...payload,
                        area_provider_location_id: providerLocationId
                    };
                    dispatch(updatePayload(updatedPayload));
                    dispatch(getHotelList(updatedPayload, signal, false, [], tabValue));
                } else {
                    dispatch(getHotelList(payload, signal, false, [], tabValue));
                }
            }
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
};
